module.exports = __webpack_public_path__ + "img/sell_info.4e7e0336.png";